import PageTitle from "../../components/PageTitle";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import PageContent from "../../components/PageContent";
import useAuth from "../../hooks/AuthHook";
import useApi from "../../hooks/ApiHook";
import { useEffect, useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import usePaginator from "../../hooks/PaginatorHook";
import { Dropdown } from 'primereact/dropdown';
import { useNavigate, useSearchParams } from "react-router-dom";

export default function() {

    const api = useApi();
    const navigate = useNavigate();
    const [ users, setUsers ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const { page, limit, setTotal, Paginator } = usePaginator();
    const [ searchParams, setSearchParams ] = useSearchParams();
    
    useEffect(() => {
        setLoading(true);
        api.get(`users?page=${page}&limit=${limit}`).then(({ data }) => {
            setUsers(data.data);
            setTotal(data.total);
            setSearchParams({ page, limit });
        }).finally(() => setLoading(false));
    }, [page, limit]);

    const actions = user => (
        <>
            <Button icon="pi pi-pencil" title="Editar" onClick={() => navigate('./' + user.id)}/>
        </>
    );

    const titleButtons = (
        <Button label="Adicionar" onClick={() => navigate('./new')}/>
    );

    const usernameColumnBody = (user) => user.loginName + '@' + user.company.loginDomain

    return (
        <div>
            <PageTitle title="Usuários" subtitle="Gerencie os usuários com acesso ao sistema" end={titleButtons}/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <DataTable value={users} selectionMode="single" emptyMessage="Nada encontrado" rowClassName={u => ({ 'opacity-40': !u.active })}>
                        <Column body={usernameColumnBody} header="Nome de usuário" style={{width:'20%'}}></Column>
                        <Column field="name" header="Nome"></Column>
                        <Column body={actions} header="Ações" align='right'></Column>
                    </DataTable>
                    <Paginator/>
                </If>
            </PageContent>
        </div>
    );
}